module.exports = __webpack_public_path__ + "17afc25e491dec92019ec3835085d2c2.svg";